import { useState } from 'react';
import { useContext, useEffect } from 'react';
import { ServicesContext } from 'app/items/shared/context_interface';
import { Cartesian2, Cartesian3 } from 'cesium';

export function useMetersPerPixel() {
    const { mapService } = useContext(ServicesContext);

    function getMetersPerPixel() {
        const { camera } = mapService.viewer;
        const { scene } = mapService.viewer;

        const originPosition = new Cartesian2(0, 0);
        const leftPosition = new Cartesian2(100, 0);

        const originRay = camera.getPickRay(originPosition);
        const leftRay = camera.getPickRay(leftPosition);
        if (!originRay || !leftRay) return undefined;

        const originCart3 = scene.globe.pick(originRay, scene);
        const leftCart3 = scene.globe.pick(leftRay, scene);

        if (originCart3 && leftCart3) {
            const distance = Cartesian3.distance(originCart3, leftCart3);
            return distance / 100;
        }
        return undefined;
    }

    const [metersPerPixel, setMetersPerPixel] = useState<number | undefined>(getMetersPerPixel());

    useEffect(() => {
        return mapService.viewer.camera.moveEnd.addEventListener(() => {
            setMetersPerPixel(getMetersPerPixel());
        });
    });

    return metersPerPixel;
}
